/**
 * ============================================
 * Sim Pack Builder — Package Filter Layer
 * ============================================
 */

(function () {
  'use strict';

  var PACKAGES = {
    qschool: {
      name: 'Q-School Package',
      tagline: 'Best for first-time simulator owners',
      range: '$5k – $9k',
      color: '#1D9E75',
      tag: 'pkg-qschool',
      desc: 'Your entry point into indoor golf. The Q-School Package delivers a complete simulator experience at an approachable price — quality core components and premium software to start practicing and playing at home.',
      metaMonitors: 'Uneekor Eye Mini Lite / Eye Mini',
      metaVisuals: '4K Gaming Monitor',
      metaEnclosure: 'Spornia Net or Net Return',
    },
    player: {
      name: 'Player Package',
      tagline: 'Best for golfers building a dedicated setup or upgrade',
      range: '$8k – $15k',
      color: '#378ADD',
      tag: 'pkg-player',
      desc: 'A step up in performance and immersion. Upgraded launch monitor, projection system, and enclosure deliver a more refined experience. Ideal for golfers who play regularly and want a permanent setup.',
      metaMonitors: '6 launch monitor options',
      metaVisuals: 'Optoma or BenQ projector',
      metaEnclosure: "Carl's DIY enclosure",
    },
    tour: {
      name: 'Tour Package',
      tagline: 'Best for serious players who want premium performance',
      range: '$10k – $20k',
      color: '#7F77DD',
      tag: 'pkg-tour',
      desc: 'Built for serious golfers who want a premium indoor experience. Higher-end launch monitors, upgraded projection, and premium enclosure materials for accurate data and truly immersive play.',
      metaMonitors: '6 premium launch monitors',
      metaVisuals: 'Short-throw projector',
      metaEnclosure: 'DIY or Pro enclosure',
    },
    champions: {
      name: 'Champions Package',
      tagline: 'Best for the ultimate home simulator experience',
      range: '$16k+',
      color: '#D85A30',
      tag: 'pkg-champions',
      desc: 'The ultimate indoor golf experience. Top-tier launch monitors paired with premium enclosures, high-performance impact screens, and fully immersive visuals. The best of everything.',
      metaMonitors: 'Trackman / GCQuad / Falcon',
      metaVisuals: 'Premium projectors (6 options)',
      metaEnclosure: "Carl's Pro enclosure",
    },
  };

  var pkg = window.SimPackage || '';
  var config = PACKAGES[pkg];

  if (!config) return;

  // ── 1. Swap headers ──
  var genericHeader = document.getElementById('spbGenericHeader');
  var pkgHeader = document.getElementById('spbPkgHeader');
  var mobileTotalBar = document.querySelector('.bak-mobile-total-bar');

  if (genericHeader) genericHeader.style.display = 'none';

  if (pkgHeader) {
    pkgHeader.style.display = 'block';

    // Move the mobile total bar to sit directly after the package hero
    // so it always appears below whichever header is visible
    if (mobileTotalBar && pkgHeader.parentNode) {
      pkgHeader.parentNode.insertBefore(mobileTotalBar, pkgHeader.nextSibling);
    }

    // Background image
    var heroImg = document.getElementById('spbImg-' + pkg);
    var heroBg = document.getElementById('spbHeroBg');
    if (heroImg && heroBg) {
      heroBg.style.backgroundImage = 'url(' + heroImg.src + ')';
    }

    // Text
    var badge = document.getElementById('spbPkgBadge');
    var title = document.getElementById('spbPkgTitle');
    var tagline = document.getElementById('spbPkgTagline');
    var range = document.getElementById('spbPkgRange');
    var desc = document.getElementById('spbPkgDesc');
    var metaMon = document.getElementById('spbMetaMonitors');
    var metaVis = document.getElementById('spbMetaVisuals');

    if (badge) badge.textContent = pkg.toUpperCase() + ' PACKAGE';
    if (title) title.textContent = config.name;
    if (tagline) tagline.textContent = config.tagline;
    if (range) range.textContent = config.range;
    if (desc) desc.textContent = config.desc;
    if (metaMon) metaMon.innerHTML = '<span class="spb-hero__meta-label">Launch Monitor</span><span class="spb-hero__meta-value">' + config.metaMonitors + '</span>';
    if (metaVis) metaVis.innerHTML = '<span class="spb-hero__meta-label">Visuals</span><span class="spb-hero__meta-value">' + config.metaVisuals + '</span>';

    pkgHeader.style.setProperty('--spb-accent', config.color);
  }

  // ── 2. Accent color on section ──
  var section = document.querySelector('.spb-section');
  if (section) {
    section.style.setProperty('--bak-blue', config.color);
    section.style.setProperty('--bak-blue-dark', config.color);
    section.style.setProperty('--bak-blue-light', config.color + '18');
    section.style.setProperty('--bak-blue-glow', config.color + '14');
  }

  // ── 3. Filter product cards ──
  var tag = config.tag;
  var grids = document.querySelectorAll('[data-step-grid]');

  grids.forEach(function (grid) {
    var stepIndex = grid.getAttribute('data-step-grid');
    var cards = grid.querySelectorAll('.bak-option-card');
    var visibleCount = 0;

    cards.forEach(function (card) {
      var cardPackages = (card.getAttribute('data-packages') || '').split(' ');
      if (cardPackages.indexOf(tag) !== -1) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    var emptyState = document.querySelector('[data-empty-step="' + stepIndex + '"]');
    if (emptyState) {
      emptyState.style.display = visibleCount === 0 ? 'block' : 'none';
    }
  });

  // ── 4. Page title ──
  document.title = config.name + ' \u2014 Build Your Sim | Sim Nation';

})();